export default {
  assetGroup: null,
  description: null,
  vehicleBrand: null,
  vehicleModel: null,
  vehicleProductionYear: null,
  sellerId: null,
  sellerContactName: null,
  sellerPhone: '',
  sellerEmail: null,
  assetsOwners: [],
  assetReportingType: '',
  assetSoldValue: null,
  assetStatus: '',
  collateralLocationCode: '',
  soldDate: null,
  valuationType: '',
  valueType: '',
  warrantyPostalCode: '',
  // appraisalPartnerName: '',
  warrantyArea: null,
  warrantyOwnerName: null,
  appraisalPartnerId: '',
  areaSizeTypeId: null
}
